import { roleRestrictions } from 'commons/src/constants';
import { FeatureToggleEnum, RequiredRoleLevel } from 'commons/src/models/commonEnums';
import { TabOption } from 'commons/src/models/menuModels';
import { paths } from '../../constants';

const businessAccountSubMenus = (customThresholdsEnabled: boolean): TabOption[] => {
    const tabOptions: TabOption[] = [
        {
            text: 'Overview',
            route: paths.settings,
            path: `/${paths.settings}`,
            testAttr: 'business-settings-overview',
            id: 'businessSettingsOverview',
            requiredRoleLevel: RequiredRoleLevel.ANY_ROLE,
            requiredGroupTypes: [],
        },
        {
            text: 'Organization',
            route: paths.organization,
            testAttr: 'settings-organization',
            id: 'settings-organization',
            path: `/${paths.organization}`,
            requiredRoleLevel: roleRestrictions.usersAndOrgManagement,
            requiredGroupTypes: [],
        },
        {
            text: 'Users',
            route: paths.userManagement,
            path: `/${paths.userManagement}`,
            id: 'settingsUserMgmt',
            testAttr: 'settings-user-mgmt',
            requiredRoleLevel: roleRestrictions.usersAndOrgManagement,
            requiredGroupTypes: [],
        },
        {
            text: 'Subscription.Subscription',
            route: paths.subscription,
            path: `/${paths.subscription}`,
            id: 'settingsSubscription',
            testAttr: 'settings-subscription',
            requiredRoleLevel: roleRestrictions.subscriptions,
            excludedFeatureToggles: [],
            requiredGroupTypes: [],
        },
    ];

    const thresholdsTab = {
        text: 'CustomThresholds.Thresholds',
        route: paths.thresholds,
        testAttr: 'account-thresholds',
        id: 'account-thresholds',
        path: `/${paths.thresholds}`,
        requiredRoleLevel: roleRestrictions.usersAndOrgManagement,
        requiredFeatureToggles: [FeatureToggleEnum.enableCustomThresholds],
        requiredGroupTypes: [],
    };
    if (customThresholdsEnabled) {
        tabOptions.splice(1, 0, thresholdsTab);
    }

    return tabOptions;
};

export default businessAccountSubMenus;
